import Sidebar from "./Sidebar";
import { Toaster } from "./ui/sonner";

export default function Layout({ children }) {
  const user = (() => { try { return JSON.parse(localStorage.getItem("helios_user")); } catch { return null; } })();
  const staffRole = user?.role === "admin" || user?.role === "technicien";
  const showBanner = staffRole && !user?.totp_enabled;
  const roleLabel = user?.role === "admin" ? "les administrateurs" : "les techniciens";
  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar />
      {/* v260 — pt-14 on mobile compensates the fixed mobile top bar height */}
      <main className="flex-1 min-w-0 pt-14 md:pt-0">
        {showBanner && (
          <div data-testid="2fa-banner" className="no-print bg-orange-500 text-white px-6 py-2 text-sm flex items-center justify-between">
            <span>⚠ <b>2FA obligatoire</b> pour {roleLabel} — activez-la depuis <a href="/ma-signature" className="underline font-semibold">Mon profil</a> {typeof user.two_factor_days_left === "number" ? `(${user.two_factor_days_left} jour${user.two_factor_days_left > 1 ? "s" : ""} restant${user.two_factor_days_left > 1 ? "s" : ""})` : "dans les 7 jours"}.</span>
          </div>
        )}
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-4 sm:py-8">{children}</div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
